import React from "react";
import "./GoogleDriveUpload.css";
import { UploadFromCompIcon } from "../FileRepo/Icons";

const UploadFromDevice = ({
  handleFileChange,
  fileInputRef,
}) => {

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  return (
        <div
          className="google-drive-popup-folder"
          onClick={handleIconClick}
          style={{ cursor: "pointer" }}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx,.xlsx,.xls,.jpg,.jpeg,.png,.txt"
            onChange={handleFileChange}
          />
          <div className="google-drive-image">
            <UploadFromCompIcon />
          </div>
          <p>Upload from Computer</p>
        </div>
  );
};

export default UploadFromDevice;
